export const StageType = Object.freeze({
	list: 'paySystemList',
	errors: 'paySystemErrors',
	result: 'paySystemResult',
	paymentInfo: 'paymentInfo',
});
